function iframeSandboxDomainStrategy(metaSiteId, experiments) {
  const iframeSandboxDomainParams = {};
  if (metaSiteId) {
    const host = experiments?.iframeSandboxSecondaryHost?.enabled ? "usrfiles" : "filesusr";
    iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
  }
  return iframeSandboxDomainParams;
}
export {
  iframeSandboxDomainStrategy as default
};
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map
